import { useFormContext } from 'react-hook-form';
import { Button } from '@ds';
import { ConditionalRender } from '@ui';

type AdminFormActionProps = {
  type: 'save' | 'create';
  showDeleteButton?: boolean;
  hasCreatePermissions?: boolean;
  hasEditPermissions?: boolean;
  hasDeletePermissions?: boolean;
  handleClick: () => void;
  handleDeleteClick?: () => void;
};

export const AdminFormAction = ({
  type,
  showDeleteButton = false,
  hasCreatePermissions = false,
  hasEditPermissions = true,
  hasDeletePermissions = false,
  handleClick,
  handleDeleteClick,
}: AdminFormActionProps) => {
  const {
    formState: { isValid, isSubmitting },
  } = useFormContext();

  const isTypeSave = type === 'save';
  const isEditDisabled = !isValid || isSubmitting || !hasEditPermissions;
  const isCreateDisabled = !isValid || isSubmitting || !hasCreatePermissions;

  return (
    <>
      <ConditionalRender show={showDeleteButton && hasDeletePermissions}>
        <div className="shrink-0">
          <Button size="md" variant="outline" color="danger" onClick={handleDeleteClick} className="min-w-32.5">
            Delete
          </Button>
        </div>
      </ConditionalRender>
      <div className="shrink-0">
        <Button size="md" variant="outline" onClick={handleClick} className="min-w-32.5">
          Discard
        </Button>
      </div>
      <div className="shrink-0">
        <Button
          size="md"
          variant="solid"
          type="submit"
          isLoading={isSubmitting}
          isDisabled={isTypeSave ? isEditDisabled : isCreateDisabled}
          className="min-w-32.5"
        >
          {isTypeSave ? 'Save changes' : 'Create'}
        </Button>
      </div>
    </>
  );
};
